import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { useSyncRef } from './syncRef';

export function useLang() {
  const { t } = useTranslation();

  const syncParams = useSyncRef({
    t,
  });

  type Translator = typeof t;

  const stableT = useCallback((...params: Parameters<Translator>) => {
    return syncParams.current.t(...params);
    // `t` is not stable between renders. We need it to be when referencing inside callbacks...
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    t: stableT as Translator,
  };
}
